import React, { useEffect, useState } from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import useDebounce from 'helpers/useDebounce';
import api from 'services';

function VesselAutoComplete({ 
    selectValue, 
    customValue = '',
    style = {}, 
    textFieldStyle = {}, 
    underlineStyle = {}, 
    floatingLabelStyle = {}, 
    hintText = '',
    menuStyle = {},
    popoverProps = {},
    inputStyle = {},
    field = '',
    handleChangeCustomValue = () => {},
    shouldClearCustomValue = false,
    fullWidth = true,
    id = '',
    dataSourceConfig = {
        withName: true,
        withImo: false,
        withBlt: false,
    },
}) {
    const [vesselValue, setVesselValue] = useState(customValue);
    const [vessels, setVessels] = useState([]);
    const [preventFirstSearch, setPreventFirstSearch] = useState(true);

    const debouncedSearchValue = useDebounce(vesselValue, 500);

    useEffect(() => { setVesselValue(''); }, [shouldClearCustomValue]);

    useEffect(() => {
        if (preventFirstSearch || !debouncedSearchValue || debouncedSearchValue.length < 2) {
            return;
        }

        api
            .findVessel(debouncedSearchValue, { confirmed: true, isNameSuggestion: false })
            .then((result) => {
                const { withName, withImo, withBlt } = dataSourceConfig;
                const _vessels = (result.data.data || []).map(_v => ({
                    ..._v,
                    compoundName: `${withName ? _v.name : ''}${withImo ? ` (${_v.imoNumber})` : ''}${withBlt ? ` (${_v.blt})` : ''}`,
                }));
                setVessels(_vessels);
            });
    }, [debouncedSearchValue]);

    useEffect(() => {
        setVesselValue(customValue);
    }, [customValue]);

    useEffect(() => {
        setPreventFirstSearch(false);
    }, []);

    const chooseVessel = (selectedValue, index) => {
        if (index < 0) {
            return;
        }
        selectValue(selectedValue);
        handleChangeCustomValue(vesselValue);
    };

    const changeVesselValue = (value) => {
        setVesselValue(value);
        handleChangeCustomValue('');
    };

    return (
        <AutoComplete 
            name='vessel'
            id={id}
            value={vesselValue}
            searchText={vesselValue}
            dataSource={vessels}
            dataSourceConfig={{ text: field || 'compoundName', value: 'item' }}
            hintText={hintText === null ? null : 'Vessel name'}
            onUpdateInput={val => changeVesselValue(val)}
            onNewRequest={(val, index) => chooseVessel(val, index)}
            filter={AutoComplete.noFilter}
            textFieldStyle={{ fontSize: '13px', ...textFieldStyle }}
            style={style}
            underlineStyle={{ ...underlineStyle }}
            floatingLabelStyle={{ ...floatingLabelStyle }}
            fullWidth={fullWidth || !style.width}
            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
            inputStyle={{ ...inputStyle }}
            popoverProps={{
                canAutoPosition: true,
                ...popoverProps,
            }}
            menuStyle={{ ...menuStyle }}
        />
    );
}

export default VesselAutoComplete;



// WEBPACK FOOTER //
// ./app/components/common/VesselAutoComplete.jsx